import { render, staticRenderFns } from "./CardCosts.vue?vue&type=template&id=6a5c169e&"
import script from "./CardCosts.vue?vue&type=script&lang=js&"
export * from "./CardCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports